module.exports = __webpack_public_path__ + "static/media/heller_EV7A2160-105.efb52112.webp";